"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-mjf-multi-jet-fusion";

const IMAGE_BASE = "/image/new-version/more/MJF/Applications";

const CATEGORIES = [
	{ titleKey: "applicationsCategory1Title", descKey: "applicationsCategory1Desc" },
	{ titleKey: "applicationsCategory2Title", descKey: "applicationsCategory2Desc" },
] as const;

const IMAGES = [
	{ src: `${IMAGE_BASE}/aerospace.webp`, labelKey: "applicationsImageLabel1" },
	{ src: `${IMAGE_BASE}/automation.webp`, labelKey: "applicationsImageLabel2" },
	{ src: `${IMAGE_BASE}/automotive.webp`, labelKey: "applicationsImageLabel3" },
	{ src: `${IMAGE_BASE}/consumer-products.webp`, labelKey: "applicationsImageLabel4" },
	{ src: `${IMAGE_BASE}/medical-devices.webp`, labelKey: "applicationsImageLabel5" },
	{ src: `${IMAGE_BASE}/robotics.webp`, labelKey: "applicationsImageLabel6" },
] as const;

export default function MjfApplications() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#fff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<span className="mb-3 inline-block text-xl uppercase tracking-wider text-themePrimary400 max-md:text-lg">
						{t("applicationsEyebrow")}
					</span>
					<h2 className="text-2xl font-bold leading-snug text-black sm:text-[30px] sm:leading-snug md:text-4xl md:leading-snug">
						{t("applicationsTitle")}
						<br />
						{t("applicationsSubtitle")}
					</h2>
					<p className="mt-4 text-sm leading-relaxed text-black md:text-base">{t("applicationsDesc")}</p>
				</div>

				<div className="grid gap-8 lg:grid-cols-[1fr_1.2fr] lg:gap-10 xl:gap-20">
					<div className="space-y-8">
						{CATEGORIES.map((cat) => (
							<div key={cat.titleKey}>
								<h3 className="mb-2 text-base font-semibold text-themePrimary400 sm:text-lg">
									{t(cat.titleKey)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(cat.descKey)}</p>
							</div>
						))}
					</div>

					<div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
						{IMAGES.map((image, index) => (
							<div
								key={image.labelKey}
								className={`group flex flex-col rounded-xl p-4 transition-colors duration-300 hover:bg-themePrimary400 ${
									index === 5 ? "bg-[#88d43c]" : "bg-[#ededed]"
								}`}
							>
								<div className="relative h-16 w-16 overflow-hidden rounded-full sm:h-20 sm:w-20">
									<Image src={image.src} alt={t(image.labelKey)} fill className="object-cover" sizes="80px" />
								</div>
								<span className="mt-4 self-end text-right text-sm font-semibold text-[#1f1f1f] group-hover:text-white sm:text-base">
									{t(image.labelKey)}
								</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
